module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_rounded_shadow.7160d97f.png";